import Kalender from './akenzo-lfs-termin-kalender';
import XDate from './akenzo-lfs-termin-xdate';

class Buchung {
    constructor() {
        this.host = window.location.hostname;
        this.xhr = {
            'finanzamt-koblenz.lfstermin': {
                url: window.lfs_termin_request_url,
                auth: false,
            },
        };
        this.dom = {};
        this.ajaxRequestSuffix = '.lfstermin.json';
        // add global class identifier
        this.class = {
            akenzoContainerClass: 'terminbuchung-content',
        };
        this.step = null;

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.init.bind(this), false);
        } else {
            this.init();
        }
        this.formTemplate = {
            headline: (data) => `
                <p>Wir rufen Sie bei einem Telefon-Termin in dem von Ihnen ausgewählten Zeitraum an.</p>
                <p class="nomargin">Freie Termine für ${data.day}</p>
            `,
            timePeriod: (data, index) => `
                <input
                    class="form-check-input"
                    id="tp-${index}"
                    type="radio"
                    name="tx_akenzolfstermin_terminbuchung[buchung][timeperiod]"
                    value="${data.from}-${data.to}"
                    data-t="${data.fromts}"
                    data-e="${data.tots}"
                    data-p="${data.from}-${data.to}"
                    ${data.selected !== false && data.selected === data.fromts ? 'checked=checked' : ''}
                >
                <label for="kategorie-4" class="form-check-label">${data.from}-${data.to} Uhr</label>
            `,
            timeOccupied: (data, index) => `
                <label for="tp-${index}" class="form-check-label occupied">
                    ${data.from}-${data.to} (Dieser Zeitraum ist belegt.)
                </label>
            `,
        };
    }

    /**
     * initialize functions
     */
    init() {
        const akenzoTermin = document.querySelector(`div[class='${this.class.akenzoContainerClass}']`);
        if (akenzoTermin !== null && akenzoTermin !== undefined) {
            if (akenzoTermin.children.length > 0) {
                this.dom = {
                    kalender: document.getElementById('lfskalender'),
                    kalenderundzeiten: document.getElementById('kalender-und-zeiten'),
                    terminliste: document.getElementById('terminliste'),
                    formular: document.getElementById('buchung'),
                    formHiddenFields: {
                        standort: document.querySelector("input[type='hidden'][name='tx_akenzolfstermin_terminbuchung[buchung][standort]']"),
                        kategorie: document.querySelector("input[type='hidden'][name='tx_akenzolfstermin_terminbuchung[buchung][kategorie]']"),
                        termin: document.querySelector("input[type='hidden'][name='tx_akenzolfstermin_terminbuchung[buchung][termin]']"),
                        provisionalToken: document.querySelector("input[type='hidden'][name='tx_akenzolfstermin_terminbuchung[buchung][provisionalToken]']"),
                        timeperiod: document.querySelector("input[type='hidden'][name='tx_akenzolfstermin_terminbuchung[buchung][timeperiod]']"),
                        daySelection: document.querySelector("input[type='hidden'][name='tx_akenzolfstermin_terminbuchung[daySelection]']"),
                        timeSeletion: document.querySelector("input[type='hidden'][name='tx_akenzolfstermin_terminbuchung[timeSeletion]']"),
                    },
                    formButtons: {
                        next: document.querySelector("button[name='tx_akenzolfstermin_terminbuchung[buchung-next]']"),
                    },
                };
                this.axajResponseHandler = {
                    updateKalender: (data) => {
                        const t = new XDate();
                        t.from(data.kalender.date).to('midnight first day of month');
                        data.date = t;
                        data.kalender = this.kalender.mergeCfg(data.kalender);
                        data.kalender.navigation.limitLeft = new XDate().to('first day of month midnight');
                        this.kalender.update(data.kalender);
                        this.dom.kalenderundzeiten.classList.remove('hidden');
                        if (this.kalender.cfg.selected
                            && this.kalender.getSelectedDays() !== null
                        ) {
                            this.kalender.getSelectedDays().dispatchEvent(new Event('click'));
                        }
                    },
                    tagAuswahl: (data) => {
                        const timeSelection = this.dom.formHiddenFields.timeSeletion.value;
                        // const termine = data.termine;
                        const firstTime = data.first;
                        const lastTime = data.last;
                        let t;
                        let d;

                        const xdate = new XDate('today midnight');
                        xdate.to(`+${firstTime} second`);

                        if (this.dom.terminliste.childNodes.length > 0) {
                            this.dom.terminliste.innerHTML = null;
                        }
                        if (firstTime !== undefined && lastTime !== undefined) {
                            for (t = firstTime; t < lastTime; t += (15 * 60)) {
                                d = document.createElement('button');
                                d.innerHTML = xdate.date('H:i');
                                d.setAttribute('data-t', t);
                                this.dom.terminliste.appendChild(d);
                                if (Object.prototype.hasOwnProperty.call(data.termine, t)) {
                                    d.classList.add('frei');
                                    d.addEventListener('click', (evnt) => {
                                        evnt.preventDefault();
                                        evnt.stopPropagation();
                                        evnt.stopImmediatePropagation();
                                        const pEChildren = evnt.target.parentElement.children;
                                        const childs = Array.from(pEChildren);
                                        childs.forEach((child) => {
                                            child.classList.remove('selected');
                                        });
                                        evnt.target.classList.add('selected');
                                        const dt = evnt.target.dataset.t;
                                        evnt.target.dispatchEvent(this.kalender.selectEvent, dt);
                                    });
                                } else {
                                    d.setAttribute('disabled', 'disabled');
                                    d.addEventListener('click', (evnt) => {
                                        evnt.preventDefault();
                                        evnt.stopPropagation();
                                        evnt.stopImmediatePropagation();
                                    });
                                }
                                xdate.to('+15 minute');
                            }
                            if (timeSelection !== '0') {
                                this.dom.terminliste.querySelector(`button[data-t='${timeSelection}']`).dispatchEvent(new Event('click'));
                            }
                        } else if (data.type !== undefined
                            && data.type === 'TP'
                            && data.termine.length > 0
                        ) {
                            let r;
                            this.dom.terminliste.classList.add('no-flex');
                            const sDay = { day: data.selectedDay };
                            this.dom.terminliste.innerHTML += this.formTemplate.headline(sDay);
                            data.termine.forEach((date, index) => {
                                const newDiv = document.createElement('div');
                                newDiv.classList.add('time-period-select');
                                this.dom.terminliste.appendChild(newDiv);
                                if (date.occupied !== undefined && date.occupied === false) {
                                    newDiv.innerHTML = this.formTemplate.timePeriod(date, index);
                                    r = this.dom.terminliste.querySelector(`input[data-t='${date.fromts}']`);
                                    r.addEventListener('change', (evnt) => {
                                        evnt.preventDefault();
                                        evnt.stopPropagation();
                                        evnt.stopImmediatePropagation();
                                        const parentEl = evnt.target.parentElement.parentElement;
                                        const pEChildren = parentEl.querySelectorAll('input[id^=\'tp-\']');
                                        Array.from(pEChildren).forEach((child) => {
                                            child.classList.remove('selected');
                                        });
                                        evnt.target.classList.add('selected');
                                        const dt = evnt.target.dataset.t;
                                        this.dom.formHiddenFields.timeperiod.value = `${date.from}-${date.to}`;
                                        evnt.target.dispatchEvent(this.kalender.selectEvent, dt);
                                    });
                                } else if (date.occupied === true) {
                                    newDiv.innerHTML = this.formTemplate.timeOccupied(date, index);
                                }
                            });
                            if (timeSelection !== '0') {
                                const selector = `input[data-t='${timeSelection}']`;
                                const evntDispatcher = this.dom.terminliste.querySelector(selector);
                                const eventReceiver = this.kalender.selectEvent;
                                evntDispatcher.dispatchEvent(eventReceiver, timeSelection);
                            }
                        }
                        this.dom.terminliste.classList.remove('hidden');
                        this.dom.terminliste.dispatchEvent(new Event('updated'));
                    },
                    terminAuswahl: () => {
                        this.dom.formButtons.next.classList.remove('disabled');
                    },
                };
                this.initStep();
                this.initEvents();
            }
        }
    }

    /* devGetQueryParams() {
        let params = {};
        if (document.location.toString().indexOf('?') !== -1) {
            let query = document.location
                .toString()
                .replace(/^.*?\?/, '')
                .replace(/#.*$/, '')
                .split('&');

            for (let i = 0, l = query.length; i < l; i++) {
                let aux = decodeURIComponent(query[i]).split('=');
                params[aux[0]] = aux[1];
            }
        }
        return params;
    } */

    requestKalenderUpdate(...args) {
        const date = (args.length) ? args[0] : this.kalender.getDate().getUnixtimestamp();

        this.query({
            q: 'updateKalender',
            standort: this.dom.formHiddenFields.standort.value,
            kategorie: this.dom.formHiddenFields.kategorie.value,
            date: date.toString(),
        });
    }

    initKalender() {
        const that = this;
        let termin = parseInt(this.dom.formHiddenFields.termin.value, 10);
        let daySelection = 0;
        const xd = new XDate();

        if (termin) {
            xd.setUnixtimestamp(termin);
            daySelection = xd.to('midnight').getUnixtimestamp();
            this.dom.formHiddenFields.daySelection.value = daySelection;
            this.dom.formHiddenFields.timeSeletion.value = termin - daySelection;

            termin = new XDate(termin).to('first day of month midnight').getUnixtimestamp();
        } else {
            termin = new XDate()
                .to('first day of month midnight')
                .getUnixtimestamp();
            this.dom.formHiddenFields.daySelection.value = 0;
            this.dom.formHiddenFields.timeSeletion.value = 0;
        }
        this.kalender = new Kalender(
            {
                id: 'kalender',
                locale: 'de',
                parent: document.getElementById('kalender-container'),
                date: termin,
                selected: daySelection,
                display: {
                    showWeekdays: true,
                },
                navigation: {
                    limitLeft: new XDate().to('first day of month midnight'),
                    limitRight: new XDate().to('first day of month midnight +3 month'),
                },
                events: {
                    onDaySelect: (evt, t) => {
                        that.dom.terminliste.classList.add('hidden');
                        that.dom.terminliste.innerHTML = null;
                        that.dom.formHiddenFields.daySelection.value = t;

                        that.query({
                            q: 'tagAuswahl',
                            tstamp: t,
                            standort: that.dom.formHiddenFields.standort.value,
                            kategorie: that.dom.formHiddenFields.kategorie.value,
                            provisionalToken: that.dom.formHiddenFields.provisionalToken.value,
                        });
                    },
                    onMonthChange: (evt, newDate) => {
                        that.dom.terminliste.classList.add('hidden');
                        that.requestKalenderUpdate(newDate);
                        that.dom.formHiddenFields.timeSeletion.value = 0;
                        that.dom.formHiddenFields.termin.value = 0;
                        that.dom.formButtons.next.classList.add('disabled');
                    },
                },
            },
        );
        this.dom.kalenderundzeiten.classList.remove('hidden');
        this.requestKalenderUpdate();
    }

    initStep() {
        const that = this;
        const buchungNext = document.querySelector('input[type="hidden"][name*="[step]"]');
        let standorte = 0;
        let categories = 0;
        this.step = parseInt(buchungNext.value, 10);
        switch (this.step) {
        case 1:
            standorte = document.querySelectorAll("input[type='radio'][name='tx_akenzolfstermin_terminbuchung[buchung][standort]']");
            if (standorte.length > 0) {
                standorte.forEach((standort) => {
                    if (standort.checked) {
                        that.dom.formButtons.next.classList.remove('disabled');
                    } else {
                        standort.addEventListener('change', () => {
                            that.dom.formButtons.next.classList.remove('disabled');
                        });
                    }
                });
            }
            break;
        case 2:
            categories = document.querySelectorAll("input[type='radio'][name='tx_akenzolfstermin_terminbuchung[buchung][kategorie]']");
            if (categories.length > 0) {
                categories.forEach((category) => {
                    if (category.checked) {
                        that.dom.formButtons.next.classList.remove('disabled');
                    } else {
                        category.addEventListener('change', () => {
                            that.dom.formButtons.next.classList.remove('disabled');
                        });
                    }
                });
            }
            break;
        case 4:
            this.initKalender();
            break;
        default:
        }
    }

    onSubmit() {
        let standorte = 0;
        let kategories = 0;

        switch (this.step) {
        case 1:
            standorte = document.querySelectorAll("input[type='radio'][name='tx_akenzolfstermin_terminbuchung[buchung][standort]']");
            if (standorte.length > 0) {
                standorte.forEach((standort) => {
                    if (standort.checked) {
                        return true;
                    }
                    return false;
                });
            }
            break;
        case 2:
            kategories = document.querySelectorAll("input[type='radio'][name='tx_akenzolfstermin_terminbuchung[buchung][kategorie]']");
            if (kategories.length > 0) {
                kategories.forEach((kategorie) => {
                    if (kategorie.checked) {
                        return true;
                    }
                    return false;
                });
            }
            break;
        case 4:
            break;

        default:
        }

        return true;
    }

    initEvents() {
        const that = this;

        this.dom.formular.addEventListener('submit', (evnt) => that.onSubmit.call(that, evnt));

        if (this.step === 4) {
            const kalenderRoot = this.kalender.getRoot();
            kalenderRoot.addEventListener('initialized', () => {
            });
            kalenderRoot.addEventListener('updated', () => {
            });
            kalenderRoot.addEventListener('pleaseReload', () => {
                that.requestKalenderUpdate();
            });

            this.dom.terminliste.addEventListener('select', (evt, time) => {
                time = time === undefined ? evt.target.dataset.t : time;
                that.query({
                    q: 'terminAuswahl',
                    standort: that.dom.formHiddenFields.standort.value,
                    kategorie: that.dom.formHiddenFields.kategorie.value,
                    termin: time,
                });
                that.dom.formHiddenFields.timeSeletion.value = time;
                const parsedTime = parseInt(time, 10);
                const daySelValue = that.dom.formHiddenFields.daySelection.value;
                const parsedDaySelection = parseInt(daySelValue, 10);
                const daySelection = parsedDaySelection + parsedTime;
                that.dom.formHiddenFields.termin.value = daySelection;
                if (evt.target.dataset.p !== undefined) {
                    that.dom.formHiddenFields.timeperiod.value = evt.target.dataset.p;
                }
            });
        }

        // remove required from strnr if the user checks the no strn checkbox
        if (this.step === 5) {
            const keineStrnrCheckbox = document.getElementById('keinestrnr-cb');
            const strnrField = document.getElementById('step5-strnr');
            if (keineStrnrCheckbox && strnrField) {
                // eslint-disable-next-line
                keineStrnrCheckbox.addEventListener('change', function () {
                    if (this.checked) {
                        strnrField.removeAttribute('required');
                    } else {
                        strnrField.setAttribute('required', 'required');
                    }
                });
            }
        }
    }

    query(data) {
        const that = this;
        const url = `${window.lfs_termin_request_url}/q/handleRequest${this.ajaxRequestSuffix}`;

        const dataJsonString = JSON.stringify(data);
        const cfg = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: dataJsonString,
        };
        if (window.location.hostname.indexOf('fin-rlp.de') < 0 && this.xhr[this.host] !== undefined && this.xhr[this.host].auth) {
            cfg.headers = { Authorization: `Basic ${btoa(this.xhr[this.host].auth)}` };
        }
        fetch(url, cfg)
            .then((response) => response.json())
            .then((result) => {
                that.handleResponse(result, 'OK', null);
            });
    }

    handleResponse(data, status, xhr) {
        // if (data.hasOwnProperty('error'))
        if (Object.prototype.hasOwnProperty.call(data, 'error')) {
            /* eslint-disable no-console */
            console.error(data.error);
            /* eslint-enable no-console */
            return;
        }
        this.axajResponseHandler[data.ep].apply(this, [data.responseData, status, xhr, data]);
    }

    /*
    function init() {
        window.d = new XDate();
        window.b = new Buchung();
    }
    */
}

export default new Buchung();
